import { newsfeedApiClient } from "./client"
import type {
  CreateArticlePayload,
  UpdateArticlePayload,
} from "@/mutators/newsfeed/NewsfeedMutator.types"
import type { IArticleRaw } from "@/models/newsfeed/newsfeed.parser"
import type { IImageUploadResponse } from "@/models/newsfeed/newsfeed.types"

export const NewsfeedMutations = {
  article: {
    create: () => ({
      mutationFn: async (payload: CreateArticlePayload) => {
        const { data } = await newsfeedApiClient.post<IArticleRaw>(
          "/admin/articles",
          payload,
        )
        return data
      },
    }),
    update: () => ({
      mutationFn: async (payload: UpdateArticlePayload) => {
        const { data } = await newsfeedApiClient.put<IArticleRaw>(
          `/admin/articles/${payload.id}`,
          payload,
        )
        return data
      },
    }),
    delete: () => ({
      mutationFn: (id: string) =>
        newsfeedApiClient.delete(`/admin/articles/${id}`),
    }),
    publish: () => ({
      mutationFn: async (id: string) => {
        const { data } = await newsfeedApiClient.post<IArticleRaw>(
          `/admin/articles/${id}/publish`,
        )
        return data
      },
    }),
    unpublish: () => ({
      mutationFn: async (id: string) => {
        const { data } = await newsfeedApiClient.post<IArticleRaw>(
          `/admin/articles/${id}/unpublish`,
        )
        return data
      },
    }),
  },
  image: {
    upload: () => ({
      mutationFn: async (file: File) => {
        const formData = new FormData()
        formData.append("image", file)
        const { data } = await newsfeedApiClient.post<IImageUploadResponse>(
          "/admin/images",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        )
        return data
      },
    }),
  },
}
